module.exports = __webpack_public_path__ + "static/img/1_0023.dcaaaba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0023.jpg
// module id = HF8N
// module chunks = 0